export default __webpack_public_path__ + "img/dbCyTrhF.97d40dd9.svg";